/**
 * Tiny event bus between the inline Retail Brief player and the site-wide
 * sticky player. The inline controls send commands; the sticky player owns the
 * single <audio> element and broadcasts its state back, so playback continues
 * while you keep browsing.
 */
export type BriefCommand = {
  action: "toggle" | "play" | "pause" | "seek" | "skip" | "speed" | "volume" | "mute";
  /** Audio URL the command targets. */
  src: string;
  value?: number;
};

export type BriefState = {
  src: string | null;
  playing: boolean;
  current: number;
  duration: number;
  speed: number;
  volume: number;
  muted: boolean;
};

const CMD_EVENT = "rna-brief-cmd";
const STATE_EVENT = "rna-brief-state";

export function sendBriefCommand(cmd: BriefCommand) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<BriefCommand>(CMD_EVENT, { detail: cmd }));
}

export function onBriefCommand(handler: (cmd: BriefCommand) => void) {
  if (typeof window === "undefined") return () => {};
  const listener = (e: Event) => handler((e as CustomEvent<BriefCommand>).detail);
  window.addEventListener(CMD_EVENT, listener);
  return () => window.removeEventListener(CMD_EVENT, listener);
}

export function emitBriefState(state: BriefState) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<BriefState>(STATE_EVENT, { detail: state }));
}

export function onBriefState(handler: (state: BriefState) => void) {
  if (typeof window === "undefined") return () => {};
  const listener = (e: Event) => handler((e as CustomEvent<BriefState>).detail);
  window.addEventListener(STATE_EVENT, listener);
  return () => window.removeEventListener(STATE_EVENT, listener);
}
